import React, {Component} from 'react';

class PrintViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {source: this.props.url}
        this.iframeRef = React.createRef();
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        const node = this.iframeRef.current;
        setTimeout(function () {
            node.contentWindow.print();
        }, 1000);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.props.close();
        }
    }

    render() {
        return (
            <div ref={this.wrapperRef}>
                <iframe ref={this.iframeRef}
                        id="print"
                        name="print"
                        src={this.state.source}
                        style={{
                            top: 0,
                            display: "none",
                            left: 0,
                            width: "100%",
                            height: "600px",
                            overlay: "none",
                        }}/>
            </div>
        );
    }
}

export default PrintViewer;